import { render } from "./PageBacklog.vue?vue&type=template&id=09e2d144"
import script from "./PageBacklog.vue?vue&type=script&lang=js"
export * from "./PageBacklog.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__